<template>
  <CCard>
    <CCardBody>

      <CCardHeader>
        <CRow>
          <CCol col="8" style="text-align: start">

            <strong>{{ $t('CashPayment') }}</strong>

          </CCol>
          <CCol col="4" style="text-align: end">
            <CButton v-if="status_form==0 && !is_year_closed()" class="mr-1 ml-1" @click="insert_data_cash()"
                     type="submit" size="sm"
                     color="secondary">
              {{ $t('buttons.save') }}
            </CButton>
            <CButton v-if="status_form!=0 && !is_year_closed()" @click="insert_data_cash()" type="submit" size="sm"
                     color="secondary">
              <CIcon name="cil-check-circle"/>
              {{ $t('buttons.editDoc') }}
            </CButton>

            <CButton v-if="status_form==0 && is_year_closed()" class="mr-1 ml-1"
                     @click="year_closed_dialog()"
                     size="sm"
                     color="danger">
              {{ $t('buttons.save') }}
            </CButton>
            <CButton v-if="status_form!=0  && is_year_closed()" class="mr-1 ml-1"
                     @click="year_closed_dialog()" type="submit"
                     size="sm"
                     color="danger">
              {{ $t('buttons.editDoc') }}
            </CButton>

            <CButton
                class="mr-1"
                size="sm"
                color="secondary"
            >{{ $t("buttons.print") }}
            </CButton>
            <CButton
                class="mr-1"
                size="sm"
                @click="empty_form()"
                color="secondary"
            >{{ $t("buttons.cancel") }}
            </CButton>
            <a :href="$route.fullPath" target="_blank">
              <CButton
                  class="mr-1 ml-1"

                  size="sm"
                  color="dark"
              >
                <CIcon size="sm" name="cil-plus"></CIcon>
              </CButton>
            </a>
          </CCol>
        </CRow>
        <!--        </div>-->

        <!-- Right aligned nav items -->
        <!--      </CCollapse>-->
      </CCardHeader>

      <CRow>
        <CCol col="3">
          <CRow form class="form-group">
            <CCol tag="label" sm="4" class="col-form-label">
              {{ $t('payer') }}
            </CCol>
            <CCol sm="8">
              <CInput v-model="selected_payer_cash_text"/>

            </CCol>
          </CRow>

        </CCol>

<!--        <CCol col="5">-->
<!--          <CRow>-->
<!--            <CCol col="7">-->
<!--              <CSelect-->
<!--                  :label="$t('payType')"-->
<!--                  :options="doc_types"-->
<!--                  :value.sync="selected_doc_type"-->
<!--                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--              />-->
<!--            </CCol>-->
<!--            <CCol col="5">-->
<!--              <CSelect-->
<!--                  :options="payer_items_data"-->
<!--                  :value.sync="selected_payer"-->
<!--                  :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"-->

<!--              />-->
<!--            </CCol>-->
<!--          </CRow>-->


<!--        </CCol>-->

        <CCol col="4">
          <CRow form class="form-group">
            <CCol tag="label" sm="4" class="col-form-label">
              {{ $t('components.payDate') }}
            </CCol>
            <CCol sm="8">
              <date-picker
                  v-model="date_cash"
                  :min="get_min_doc_date()"
                  :max="get_max_doc_date()"
              ></date-picker>

            </CCol>
          </CRow>

        </CCol>

      </CRow>

      <CRow>
        <CCol col="12">

          <CDataTableFixed
              height="300px"

              :items="items_pay_cash"
              :fields="fields_pay_cash"
              striped
              border
              :items-per-page="200"
              hover
              pagination
          >
            <template #row="{item,index}">

              <td>
                <label>{{ index + 1 }}</label>
              </td>
            </template>
            <template #pay_for="{item}">
              <td>
                <CInput
                    :placeholder="$t('description')"
                    v-model="item.summary"
                />
              </td>
            </template>

            <template #resource="{item,index}">
              <td>
                <CRow class="m-0">
                  <CCol col="5" class="p-0">
                    <CSelect
                        :options="doc_types"
                        :value.sync="item.selected_doc_type"

                    />
                  </CCol>
                  <CCol col="7" class="p-0">
                    <CSelectDefaultValue
                        :options="payer_items_data.filter(x=>x.doc_type==item.selected_doc_type)"
                        :value.sync="item.selected_payer"
                        @change="get_bank_remaining(item,index,'when is select')"
                    />
                  </CCol>
                  <br>
                  <label
                      v-if="item.remaining_bank!=null"
                  >{{ $t('tables.balance') }} : {{ get_currency(item.remaining_bank) }}</label>


                </CRow>
              </td>
            </template>
            <template #payer="{item,index}">
              <td>
                <CRow class="m-0">
                  <CCol class="p-0" col="5">
                    <CSelect
                        v-if="item.document_refrence== null"
                        :options="master_types"
                        @change="clear_tafsili_selected(item)"
                        :value.sync="item.selected_master_type"
                    />
                    <!--                    @change="select_moein(item,index)"-->
                    <label v-else>{{ $t('factor') }}</label>

                  </CCol>
                  <CCol class="p-0" col="7">
                    <treeselect
                        v-if="item.document_refrence== null"
                        v-model="item.selected_tafsili"
                        :options="item.tafsili_list"
                        appendToBody
                        @search-change="add_master_to_search(item)"
                        :async="true"
                        valueFormat="object"

                        :load-options="load_tafsilis"
                        @select="get_person_remaining_amount(index,item,...arguments)"

                        :placeholder="$t('components.searchUser')"
                        :normalizer="normalizer_tafsili"
                    />
                    <label v-else>{{ item.document_person_name }}</label>
                    <br>
                    <label
                        v-if="item.remaining!=null && (item.document_refrence!= null || item.selected_tafsili!=null)"
                    >{{ $t('tables.balance') }} : {{ get_currency(item.remaining) }}</label>

                  </CCol>
                </CRow>
              </td>
            </template>
            <template #reference="{item,index}">
              <td>
                <CRow>
                  <CCol col="10">
                    <treeselect

                        v-model="item.document_refrence"
                        appendToBody
                        :async="true"
                        :disabled="item.selected_master_type==70||item.selected_master_type==74||item.selected_master_type==pos_id"
                        @select="select_refrence_cash(item,index)"
                        valueFormat="object"
                        :cacheOptions="false"
                        @open="focus_reference(item,index)"
                        :load-options="load_reference"
                        :placeholder="$t('searchReference')"
                        :normalizer="normalizer_refrence"
                    />
                    <label v-if="item.invoice_remaining && item.document_refrence!=null">{{ $t('tables.balance') }} :
                      {{ get_currency(item.invoice_remaining) }}</label>

                  </CCol>
                  <CCol col="2" class="p-0 m-0">
                    <CIcon v-if="item.document_refrence!=null"
                           @click.native="get_invoice_report(item.document_refrence)" name="cil-magnifying-glass"/>
                  </CCol>
                </CRow>


              </td>
            </template>
            <template #amount="{item}">

              <td>
                <CInputCurrency
                    @keypress="isDecimal2($event,item.amount)"

                    v-model="item.amount"
                />
              </td>

            </template>
            <template #operation="{item,index}">
              <td>
                <CButton
                    class="mr-1"
                    size="sm"
                    @click="items_pay_cash.splice(index, 0, {selected_master_type: 163,selected_doc_type:70});"
                    color="dark"
                >
                  <CIcon size="sm" name="cil-plus"></CIcon>
                </CButton>
                <CButton v-if="items_pay_cash.length>1"
                         class="mr-1"
                         size="sm"
                         @click="items_pay_cash.splice(index,1)"
                         color="primary"
                >
                  <CIcon size="sm" name="cil-minus"></CIcon>
                </CButton>
              </td>

            </template>


          </CDataTableFixed>

        </CCol>

        <CCol>
          <label>{{ $t('totalSum') }} : {{ get_currency(cash_total) }}</label>
        </CCol>
      </CRow>


    </CCardBody>
    <CModal
        color="dark"
        size="lg"
        :show.sync="invoice_info"
    >
      <CDataTableFixed
          :items="items_invoice"
          :fields="fields_invoice"
          :items-per-page="200"
          hover

          border
          striped

      >
        <template #row="{item,index}">

          <td>
            <p class="text-center">{{ index + 1 }}</p>

          </td>

        </template>
        <template #docDate="{item}">

          <td>
            <p class="text-center">{{ get_date(item.docDate) }}</p>

          </td>

        </template>

        <template #balance="{item}">
          <td>
            <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
            <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
            <p class="text-right text-danger" v-if="item.balance<0">{{ get_currency(Math.abs(item.balance)) }}</p>
            <p class="text-right" v-else>{{ get_currency(item.balance) }}</p>

          </td>
        </template>

        <template #amount="{item}">
          <td>
            <p class="text-right">{{ get_currency(item.amount) }}</p>
          </td>
        </template>
        <template #amountNegetive="{item}">
          <td>
            <p class="text-right">{{ get_currency(item.amountNegetive) }}</p>
          </td>
        </template>
        <template #partyName="{item}">

          <td>
            <p>{{ item.partyName }}</p>

          </td>

        </template>
        <template #toziKonande="{item}">

          <td>
            <p v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>

          </td>

        </template>
        <template #user="{item}">
          <td>
            <p>{{ item.createdBy }}</p>
          </td>
        </template>
        <template #masterCode="{item}">
          <td>
            <p class="text-center">{{ item.masterCode }}</p>
          </td>
        </template>


        <template #operation="{item}">
          <td>

            <CButton v-if="item.statusId ==0"

                     size="sm"
                     :title="$t('buttons.finalize')"
                     @click="Finalize(item)"
            >
              <CIcon name="cil-trash" class="text-danger"/>
            </CButton>


          </td>
        </template>

        <template #under-table>
          <CRow>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol>{{ $t('totalCirculation') }}</CCol>
            <CCol>{{ get_currency(calculate_items(items_invoice, 'amountNegetive')) }}</CCol>
            <CCol>{{ get_currency(calculate_items(items_invoice, 'amount')) }}</CCol>
            <CCol></CCol>

          </CRow>
          <CRow>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>
            <CCol class="bg-dark text-danger" v-if="calculate_items(items_invoice,'amountNegetive')
                - calculate_items(items_invoice,'amount')<0">{{
                get_currency(Math.abs(calculate_items(items_invoice, 'amountNegetive')
                    - calculate_items(items_invoice, 'amount')))
              }}
            </CCol>
            <CCol class="bg-dark" v-else>{{
                get_currency(calculate_items(items_invoice, 'amountNegetive')
                    - calculate_items(items_invoice, 'amount'))
              }}
            </CCol>
            <CCol></CCol>

            <CCol></CCol>
          </CRow>

        </template>

      </CDataTableFixed>

      <template #footer>
        <CButton @click="invoice_info = false" color="danger">{{ $t('buttons.close') }}</CButton>
      </template>
    </CModal>

  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";
import PayingOrders from "./PayingOrders";
import Vue from "vue";

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
export default {
  name: 'PayOperation',
  components: {
    Treeselect,

  },

  data() {
    return {
      pos_id: 306,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      master_id: null,
      search_master_type: null,
      master_types: [],
      active_tab: 0,
      search_reference_master: 0,
      searched_refrences: [],
      selected_payer_cash_text: '',
      date_cash: '',
      summary: '',
      selected_focus_reference: null,
      cashiers: [],
      banks: [],
      payer_items_data: [],
      terminals: [],
      selected_payer: 0,
      selected_receiver_cheque: null,
      doc_types: [],
      selected_doc_type: 70,
      status_form: 0,
      price: '',
      invoice_info: false,
      items_invoice: [],
      fields_invoice: [
        {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%;text-align:center'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
        {key: 'accNo', label: this.$t('docNumber'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:10%'},

        {key: 'amount', label: this.$t('bedehkar'), _style: 'width:10%'},
        {key: 'amountNegetive', label: this.$t('bestankar'), _style: 'width:10%'},

        {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},

      ],
      items_accounting_groups: [],
      selected_accounting_group: null,
      items_accounting_sub_groups: [],
      selected_accounting_sub_group: null,
      items_accounting_data: [],

      fields_pay_cash: [
        // {key: 'row', label: "No.", _style: 'width:2%;padding:0px'},
        {key: 'payer', label: this.$t('DebtorAccount'), _style: 'width:15%;padding:0px'},
        {key: 'resource', label: this.$t('payType'), _style: 'width:10%;padding:0px'},
        {key: 'reference', label: this.$t('reference'), _style: 'width:7%;padding:0px'},

        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:5%;padding:0px'},

        {key: 'pay_for', label: this.$t('payForDescription'), _style: 'width:7%;padding:0px'},

        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;padding:0px'},
      ],
      items_pay_cash: [{selected_master_type: 163, selected_doc_type: 70}],

      searched_person: [],
      document_person: null,
      document_person_cheque: null,
      search_user_async: true,

      normalizer_documents(node) {
        return {
          id: node.id,
          label: node.label,
        }
      },
      normalizer_tafsili(node) {
        return {
          id: node.recId,
          label: node.recTitle,
        }
      },
      normalizer_refrence(node) {
        return {
          id: node.factorMasterId,
          label: node.masterCode,
        }
      },
      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('tables.payDate'), _style: 'padding:0px'},
        {key: 'receiver', label: this.$t('tables.customer'), _style: 'padding:0px'},
        {key: 'payer', label: this.$t('tables.payer'), _style: 'padding:0px'},
        {key: 'payType', label: this.$t('tables.payType'), _style: 'padding:0px'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],
      items: [],
      selected_master_type_item: 0,

      get_items: [1],
      cheque_banks: [],
    }
  }, mounted() {
    // this.select_moein(this.items_pay_cash[0], 0)
    if (this.$i18n.locale == "fa") {
      this.pos_id = 77
    }
    this.master_types = [
      {value: 163, label: this.$t('Suppliers')},
      {value: 80, label: this.$t('Customers')},

      {value: 92, label: this.$t('persons')},
      {value: 91, label: this.$t('components.employee')},
      {value: 70, label: this.$t('components.cash')},
      {value: 74, label: this.$t('components.bank')},
      {value: this.pos_id, label: this.$t('components.pos')},
      {value: 288, label: this.$t('collector')},
      {value: 0, label: this.$t('Other')},
    ];
    this.doc_types = [
      {value: 70, label: this.$t('components.cash')},
      {value: 74, label: this.$t('components.bank')},
      {value: this.pos_id, label: this.$t('components.pos')},
      {value: 100, label: this.$t('tables.off')},

      {value: 288, label: this.$t('onTheWay')},


    ]
    this.date_cash = this.get_today();
    if (this.date_cash > this.get_max_doc_date()) {
      this.date_cash = this.get_max_doc_date()
    }
    if (this.date_cash < this.get_min_doc_date()) {
      this.date_cash = this.get_min_doc_date()
    }
    // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML
    this.get_banks();

    this.get_lists_groups();
    // this.select_moein();


    if (this.$route.params.product_id != null) {
      this.editable = true;
      this.status_form = this.$route.params.product_id;
      this.get_product_data();
    }
  }, watch: {
    '$route.params.product_id': function () {
      this.get_product_data();
    },
    'selected_accounting_group': function () {
      this.get_lists_sub_groups();
    }
  },
  computed: {

    cash_total() {
      var total = 0;
      this.items_pay_cash.forEach((val) => {
        if (val.amount != null) {
          total += parseFloat(val.amount);

        }
      });
      return total;
    },


    payfor_items() {
      var items = [];

      return items;
    },
  },
  methods: {
    clear_tafsili_selected(item) {
      console.log("clear tafsili")
      item.selected_tafsili = null
    },

    select_moein(item, index) {
      var self = this;

      const formData = new FormData();
      var url = "GetAccTafsilisByAccountId";
      formData.append("accId", item.selected_master_type);
      // formData.append("accId", this.selected_master_type);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              // item.tafzili_list = response.data.data;
              // item.tafsili_list = response.data.data;
              // Vue.set(item, "tafsili_list", response.data.data);
              Vue.set(self.items_pay_cash[index], "tafsili_list", response.data.data);

              if (item.tafsili_list.length > 0) {
                item.selected_tafsili = item.tafsili_list[0].value;

              } else {
                self.selected_tafsili = null;

              }
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      ).catch(function (error) {
        console.log(error);
      });

    },

    load_tafsilis({action, searchQuery, callback}) {

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();
          console.log("search called", this.search_reference_master)
          var url = "GetAccTafsilisByAccountId";
          formData.append("accId", this.search_master_type);
          formData.append('SearchTxt', searchQuery);

          axios.post(url, formData, {show_pros: false}).then(function (response) {
            options = response.data.data;

            callback(null, options);

            // localStorage.setItem("api_token", response.data.access_token);
            // self.$router.push({ path: 'notes' });
          })
              .catch(function (error) {
                console.log(error);
              });
        })
      }
    },

    load_reference({action, searchQuery, callback}) {
      var self2 = this;
      var id = self2.search_reference_master
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          const formData = new FormData();
          if (id == null) {
            id = 0;
          }
          formData.append('Id', id);
          formData.append('SearchTxt', searchQuery);
          formData.append('TypeId', this.selected_master_type_item);

          axios.post('GetFactorsByPartyId', formData, {show_pros: true}).then(function (response) {
            // options = response.data.data;
            // self2.searched_refrences = response.data.data;

            if (self2.items_pay_cash[self2.selected_focus_reference].selected_tafsili != null) {
              var selected_tafsili_tmp = self2.items_pay_cash[self2.selected_focus_reference].selected_tafsili.recId

              options = response.data.data.filter(x => x.partyId == selected_tafsili_tmp);
              self2.searched_refrences = response.data.data.filter(x => x.partyId == selected_tafsili_tmp);
            } else {
              options = response.data.data;
              self2.searched_refrences = response.data.data;
            }

            callback(null, options);

            // localStorage.setItem("api_token", response.data.access_token);
            // self.$router.push({ path: 'notes' });
          })
              .catch(function (error) {
                console.log(error);
              });
        })
      }
    },
    add_master_to_search(item) {
      console.log("search item search");
      this.search_reference_master = item.document_person
      this.search_master_type = item.selected_master_type
    },
    select_refrence_cash(item, index) {
      // this.search_reference_master = item.document_person
      var self2 = this
      console.log("search item search", self2.searched_refrences);

      setTimeout(() => {
        Vue.set(self2.items_pay_cash[index], "document_person_name", item.document_refrence.partyName);
        Vue.set(self2.items_pay_cash[index], "document_person", item.document_refrence.partyId);
        self2.get_person_remaining_amount(index, item, {recId: item.document_refrence.partyId})
        self2.get_invoice_remaining(item, index);
      }, 200);

    },
    get_person_remaining_amount(index2, item, e) {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));
      var url = ""
      if ([80, 91, 92, 163].includes(item.selected_master_type)) {
        url = "GetLastPartyAccountByParam"

      } else {
        url = "GetPersonAccountsByPersonId_New"
      }
      if (item.selected_master_type == 80) {//customers
        formData.append('TafsiliType', 2);
      } else if (item.selected_master_type == 163) {//suppliers
        formData.append('TafsiliType', 3);
      } else if (item.selected_master_type == 70) {
        formData.append('TafsiliType', 6);
      } else if (item.selected_master_type == 288) {
        formData.append('TafsiliType', 7);
      } else {
        formData.append('TafsiliType', 5);
      }

      formData.append('id', 0);

      formData.append('PartyId', e.recId);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if ([80, 91, 92, 163].includes(item.selected_master_type)) {
            if(item.selected_master_type==163){
              response.data.data.balance = response.data.data.balance*-1
            }
            Vue.set(self.items_pay_cash[index2], "remaining", response.data.data.balance);

          } else {
            var items1 = content_data.data.personAccountItems.map((item, row_id) => {
              return {...item, row_id}
            });
            items1.forEach(function (val, index) {
              if (index == 0) {
                val.reminingBefore = 0;
                if (val.natureId == 0 && self.items[index + 1] != null) {
                  val.natureId = self.items[index + 1].natureId;
                }
                // val.accBalance = val.accBalance
              } else {
                val.reminingBefore = self.items[index - 1].accBalance;

                if (val.natureId == 2) {
                  val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                  // val.accBalanceFinal =val.accBalance
                  if (val.amount > 0) {
                    val.amountNegetive = Math.abs(val.amount);
                    val.amount = 0;

                  } else {
                    val.amount = Math.abs(val.amount);
                    val.amountNegetive = 0;
                  }
                } else {

                  val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                  if (val.amount < 0) {
                    val.amountNegetive = 0;
                    val.amount = Math.abs(val.amount);

                  } else {
                    val.amountNegetive = Math.abs(val.amount);
                    val.amount = 0;

                  }
                }
              }

              Vue.set(self.items_pay_cash[index], "remaining", items1[items1.length - 1].accBalance * -1);

              // item.remaining

            })

          }

          // response.data.data.balance
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_bank_remaining(item, index2, e) {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));
      if (item.selected_doc_type == 80) {//customers
        formData.append('TafsiliType', 2);
      } else if (item.selected_doc_type == 163) {//suppliers
        formData.append('TafsiliType', 3);
      } else if (item.selected_doc_type == 70) {
        formData.append('TafsiliType', 6);
      } else if (item.selected_doc_type == 288) {
        formData.append('TafsiliType', 7);
      } else {
        formData.append('TafsiliType', 5);
      }
      formData.append('id', item.selected_payer);

      formData.append('PartyId', item.selected_payer);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);
      axios.post('GetPersonAccountsByPersonId_New', formData, {show_pros: false}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          var items1 = content_data.data.personAccountItems.map((item, row_id) => {
            return {...item, row_id}
          });
          items1.forEach(function (val, index) {
            if (index == 0) {
              val.reminingBefore = 0;
              if (val.natureId == 0 && self.items[index + 1] != null) {
                val.natureId = self.items[index + 1].natureId;
              }
              // val.accBalance = val.accBalance
            } else {
              val.reminingBefore = self.items[index - 1].accBalance;

              if (val.natureId == 2) {
                val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                // val.accBalanceFinal =val.accBalance
                if (val.amount > 0) {
                  val.amountNegetive = Math.abs(val.amount);
                  val.amount = 0;

                } else {
                  val.amount = Math.abs(val.amount);
                  val.amountNegetive = 0;
                }
              } else {

                val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
                if (val.amount < 0) {
                  val.amountNegetive = 0;
                  val.amount = Math.abs(val.amount);

                } else {
                  val.amountNegetive = Math.abs(val.amount);
                  val.amount = 0;

                }
              }
            }
            self.items_pay_cash.forEach(function (val, val_index) {
              if (val.selected_payer == item.selected_payer && index2 != val_index) {
                if (val.amount != null) {
                  items1[items1.length - 1].accBalance -= val.amount
                }
              }
            })

            Vue.set(self.items_pay_cash[index2], "remaining_bank", (items1[items1.length - 1].accBalance));

            // item.remaining

          })
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_invoice_remaining(item, index) {

      var self = this;
      var formData = new FormData();

      var url = "GetPersonAccountsByFactorId";

      // formData.append("FromDate", self.get_day_before_today_in_day(365));
      // formData.append("ToDate", self.get_today());
      formData.append('FactorId', item.document_refrence.factorMasterId);
      // formData.append('FactorId', 3667);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          var items_invoice1 = content_data.data.personAccountItems.map((item, row_id) => {
            return {...item, row_id}
          });
          var last_balance = 0;
          items_invoice1.forEach(function (val) {
            val.balance = last_balance + parseFloat(val.amount);
            if (parseFloat(val.amount) > 0) {
              val.amountNegetive = Math.abs(parseFloat(val.amount))
              val.amount = 0;
            } else {
              val.amountNegetive = 0
              val.amount = Math.abs(parseFloat(val.amount))
            }
            last_balance = val.balance;
          });
          Vue.set(self.items_pay_cash[index], "invoice_remaining", last_balance);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },

    insert_data_cash() {
      if (!this.validateFormCash()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddCashPayment_New";
      } else {
        url = "EditCashPayment";
        formData.append('id', this.status_form)

      }
      var master = {
        PaymentTypeId: this.selected_doc_type, AccountTypeId: 2,
        DocDate: this.date_cash
      };
      master.PayerId = this.selected_payer_cash_text;

      var details = [];
      for (var i = 0; i < this.items_pay_cash.length; i++) {
        if (this.items_pay_cash[i].amount != "" &&
            this.items_pay_cash[i].amount != null &&
            this.items_pay_cash[i].amount != "0") {
          var factor_master_id = 0;
          var party_id = null
          if (this.items_pay_cash[i].document_person != null) {
            factor_master_id = this.items_pay_cash[i].document_refrence.factorMasterId
            party_id = this.items_pay_cash[i].document_person
          } else {
            party_id = this.items_pay_cash[i].selected_tafsili.recId

          }
          var obj = {
            PartyId: party_id,
            DocMasterId: factor_master_id,
            MasterType: this.items_pay_cash[i].master_type,
            PayDesc: this.items_pay_cash[i].summary,
            CashierId: this.items_pay_cash[i].selected_payer,
            PartyAccountId: this.items_pay_cash[i].selected_master_type,
            PaymentTypeId: this.items_pay_cash[i].selected_doc_type,
            Amount: (this.items_pay_cash[i].amount * -1)
          };
          if (obj.PartyAccountId == 0) {
            obj.PartyAccountId =  this.items_pay_cash[i].selected_tafsili.accountId

          }
          if (self.items_pay_cash[i].selected_doc_type == 100) {
            obj.PayDesc = self.$t('tables.off')
          }
          if (obj.MasterType == null) {
            obj.MasterType = 1;
          }
          if (obj.DocMasterId == null) {
            obj.DocMasterId = 0;
          }
          details.push(obj)
        }
      }
      var send_obj = {Master: master, Details: details}
      formData.append('model', JSON.stringify(send_obj));
      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        if (res.data.statusCode == 0) {
          self.name = '';
          self.added_product = res.data.data.id;
          self.color = '';
          self.description = '';
          self.previewImage = '';
          self.weight = '';
          self.selected_unit = '0';
          self.selected_brand = '0';
          self.selected_category = '0';
          self.barcode = '';
          self.selected_payer_cash_text = ""
          self.items_pay_cash = [{selected_master_type: 163}]

          bus.$emit("update_add_pay", "");

          self.$root.modal_component.show_api_response_modals(res);

        } else {
          // this.$router.push({path:'/dashboard/products/list'})
          self.$root.modal_component.show_api_response_modals(res);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    validateFormCash: function () {
      this.$root.root_validate_errors = [];

      // if (this.items_pay_cash[0].document_refrence == null || this.items_pay_cash[0].amount == null || this.items_pay_cash[0].amount == "") {
      //   console.log("receiver reference amount")
      //
      //   return false;
      // }
      // if (this.selected_receiver_cash == null && this.selected_payer_cash_text == '' ) {
      //  console.log("receiver error",this.selected_receiver_cash,this.selected_payer_cash_text)
      //   return false;
      // }
      //
      // return true;

      // if (this.selected_payer_cash_text == '') {
      //   this.$root.root_validate_errors.push(this.$t('Insert Recipient by'));
      //
      //   return false;
      // }
      for (var i = 0; i < this.items_pay_cash.length; i++) {
        if (this.items_pay_cash[i].document_person != null) {
          if (this.items_pay_cash[i].amount == "" || this.items_pay_cash[i].amount == null) {
            this.$root.root_validate_errors.push(this.$t('Insert Amount'));

          }
        }
      }
      return true;
      // e.preventDefault();
    },

    get_banks() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.banks = content_data.data;

          self.banks.forEach((val) => {
            var obj = {label: val.bankAccTitle, value: val.id}
            self.cheque_banks.push(obj)
          });
          self.get_cashiers();
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers = content_data.data;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
        self.get_terminals();

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_discounts() {
      var self = this;

      const formData = new FormData();
      var url = "GetAccTafsilisByAccountId";
      let off_id = 100
      // if(this.docType==1){
      //   off_id = 100
      //
      // }
      formData.append("accId", off_id);

      // formData.append("accId", this.selected_master_type);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              content_data.data.forEach((val) => {
                var obj = {label: val.recTitle, value: val.recId, doc_type: off_id}
                self.payer_items_data.push(obj)
              });
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      ).catch(function (error) {
        console.log(error);
      });

    },

    get_terminals() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankTerminals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.terminals = content_data.data;
          self.cashiers.filter(x => x.accountId == 70).forEach((val) => {
            var obj = {label: val.boxTitle, value: val.id, doc_type: 70}
            self.payer_items_data.push(obj)
          });

          self.cashiers.filter(x => x.accountId == 288).forEach((val) => {
            var obj = {label: val.boxTitle, value: val.id, doc_type: 288}
            self.payer_items_data.push(obj)
          });

          self.banks.forEach((val) => {
            var obj = {label: val.bankAccTitle, value: val.id, doc_type: 74}
            self.payer_items_data.push(obj)
          });

          self.terminals.forEach((val) => {
            var obj = {label: val.terminalTitle, value: val.id, doc_type: self.pos_id}
            self.payer_items_data.push(obj)
          });

          self.get_discounts()
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    focus_reference(item, index) {
      this.selected_focus_reference = index
      console.log('selec_reference', index)
      this.selected_master_type_item = item.selected_master_type

    },
    get_lists_groups() {
      var self = this;
      self.items_accounting_groups = [];
      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              self.items_accounting_data = response.data.data.map((item, row_id) => {
                return {...item, row_id}
              })

              var obj2 = {
                label: "All",
                id: 0,
              }
              self.items_accounting_groups.push(obj2)

              // console.log(self.data);
              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  self.get_childrens_one_sub(val.id, self.items_accounting_data).forEach((val2) => {

                    self.get_childrens_one_sub(val2.id, self.items_accounting_data).forEach((val3) => {
                      var obj2 = {
                        label: val3.accountName,
                        code: val3.accountCode,
                        id: val3.id,
                      }

                      self.items_accounting_groups.push(obj2)

                    });
                  });

                }

              });
              // self.filter_data();

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_sub_groups() {
      var self = this;
      this.items_accounting_sub_groups = []
      this.selected_accounting_sub_group = null


      self.get_childrens_one_sub(this.selected_accounting_group, self.items_accounting_data).forEach((val2) => {
        var obj2 = {
          label: val2.accountName,
          code: val2.accountCode,
          id: val2.id,
        }
        self.items_accounting_sub_groups.push(obj2)

      });


    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },
    get_invoice_report(item) {

      var self = this;
      var formData = new FormData();

      var url = "GetPersonAccountsByFactorId";

      // formData.append("FromDate", self.get_day_before_today_in_day(365));
      // formData.append("ToDate", self.get_today());
      formData.append('FactorId', item.factorMasterId);
      // formData.append('FactorId', 3667);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.items_invoice = content_data.data.personAccountItems.map((item, row_id) => {
            return {...item, row_id}
          });
          var last_balance = 0;
          self.items_invoice.forEach(function (val) {
            val.balance = last_balance + parseFloat(val.amount);
            if (parseFloat(val.amount) < 0) {
              val.amountNegetive = Math.abs(parseFloat(val.amount))
              val.amount = 0;
            } else {
              val.amountNegetive = 0
            }
            last_balance = val.balance;
          });
          self.invoice_info = true;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },


  }
}

</script>
